import React, { useState } from "react";
import "./newFrais.scss";

import { Close, SchoolOutlined } from "@mui/icons-material";

import "react-phone-input-2/lib/style.css";
import { IconButton } from "@mui/material";
import {
  classeType,
  montantType,
  requestType,
  schooYearType,
} from "../../../types/GlobalType";
import { API_CONFIG } from "../../../apiCaller/configuration.Caller";
import toast, { LoaderIcon } from "react-hot-toast";
import { accountService } from "../../../_services/accountServices";
import { catchErrorApiCall } from "../../../_services/apiUtils";
import ErrorBar from "../../../component/errorComp/ErrorBar.tsx";
import { useNavigate, useNavigation } from "react-router-dom";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  data: montantType | undefined;
  dataClasse: classeType[];
  dataYear: schooYearType[];
  dispatchReload: () => void;
  selectedClasseId: number | string | undefined;
  selectedAnneeId: number | string | undefined;
}

const UpdateFrais = (props: Props) => {
  const [classeDesignationId, setclasseDesignationId] = useState<any>(
    props.data?.classe_id
  );
  const [anneeDesignation, setanneeDesignation] = useState<any>(
    props.data?.annee_scolaire_id
  );
  const [montantDesignation, setmontantDesignation] = useState<any>(
    props.data?.montant
  );

  const [isValidNumber, setIsValidNumber] = useState(true);

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  let targetItemClasse: classeType | undefined;
  let remainingItemsClasse: classeType[] = [];

  let targetItemAnnee: schooYearType | undefined;
  let remainingItemsAnnee: schooYearType[] = [];

  // Function to handle input change
  for (let value of props.dataClasse) {
    if (value.classe_id === props.selectedClasseId) {
      targetItemClasse = value;
    } else {
      remainingItemsClasse.push(value);
    }
  }

  for (let value of props.dataYear) {
    if (value.annee_scolaire_id === props.selectedAnneeId) {
      targetItemAnnee = value;
    } else {
      remainingItemsAnnee.push(value);
    }
  }

  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const value = event.target.value;
    setmontantDesignation(value);

    // Check if the input value is a valid number
    const isNumber = !isNaN(value) && value.trim() !== "";
    setIsValidNumber(isNumber);
  };

  const handleUpdateMontant = async () => {
    if (montantDesignation.toString().length < 1) {
      return setState({
        ...state,
        errorMessage: "Veuiller complétez le montant",
      });
    }
    if (!isValidNumber) {
      return setState({
        ...state,
        errorMessage: "Veuiller complétez un montant valide",
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }

    try {
      let data = {
        montant: montantDesignation,
        classe_id: props.selectedClasseId,
        annee_scolaire_id: props.selectedAnneeId,
      };
      const response = await API_CONFIG.MONTANT_ANNUEL.update(
        props.data?.montant_id,
        data,
        token
      );
      console.log(response);
      if (response.data.status === 200) {
        toast.success("Montant annuel ajouté avec succes", {
          duration: 3000,
        });
        setmontantDesignation("");
        props.setOpen(false);
        props.dispatchReload();
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
          },
        });
      }
    } catch (error) {
      setState({ ...state, isLoading: false });
      catchErrorApiCall(error);
    }
  };

  return (
    <div className="NewFrais">
      <div className="dialog_update">
        <div className="headerUpdate">
          <div className="titleUpdate">
            <div className="left_">
              <SchoolOutlined className="ico" />
              <span>Modification - Frais scolaire</span>
            </div>
            <IconButton>
              <Close className="ico" onClick={() => props.setOpen(false)} />
            </IconButton>
          </div>
        </div>

        <div className="body_update">
          {state.errorMessage && <ErrorBar title={state.errorMessage} />}

          <div className="item">
            <label>Classe</label>
            <div className="role-selector">
              <select
                value={classeDesignationId}
                onChange={(e) => setclasseDesignationId(e.target.value)}
                className="input-field"
              >
                <option value={targetItemClasse?.classe_id}>
                  {targetItemClasse?.classe_designation}
                </option>
                {remainingItemsClasse.map((item, index) => {
                  return (
                    <option key={index} value={item.classe_id}>
                      {item.classe_designation}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="item">
            <label>Année scolaire</label>
            <div className="role-selector">
              <select
                value={anneeDesignation}
                onChange={(e) => setanneeDesignation(e.target.value)}
                className="input-field"
              >
                <option value={targetItemAnnee?.annee_scolaire_id}>
                  {targetItemAnnee?.annee_scolaire_designation}
                </option>
                {remainingItemsAnnee.map((item, index) => {
                  return (
                    <option key={index} value={item.annee_scolaire_id}>
                      {item.annee_scolaire_designation}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="item">
            <label>{"Frais scolaire"}</label>
            <input
              placeholder="Montant"
              type="text"
              name="amount"
              value={montantDesignation}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="btn">
          <button onClick={() => props.setOpen(false)}>Annuler</button>
          {state.isLoading ? (
            <button>
              <LoaderIcon />
            </button>
          ) : (
            <button onClick={handleUpdateMontant}>Enregister</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdateFrais;
